<template>
  <div id="SlotMachine">

    <div class="body">
      <div class="left_hand"></div>
      <div class="box"></div>
      <div class="window">
        <!--  -->
        <div class="container">
          <Gift v-for="(config, index) in configs" @finished="isFinished" :trigger="trigger" :config="config"
            :key="index">
          </Gift>
          <div class="fence1"></div>
          <div class="fence2"></div>
        </div>
        <!--  -->
      </div>

      <div :class="['handler', { 'active': active }, { 'disabled': disabled }]">
        <div class="stick"></div>
      </div>
      <div class="btn_box">
        <div class="btn" @click="!disabled && turn()"></div>
      </div>
      <div class="btn_background"></div>
      <div class="screen">
        <div class="screen_content">
          <div class="screen_content_item" v-for="item in screen_content">
            <div v-if="item.lock" @click="!disabled && bubbling('banShow')" class="lock"> </div>
            <div class="screen_content_item_text" :key="item.path"
              :style="{ 'background-image': 'url(' + item.path + ')' }"></div>
            <template v-if="item._get">
              <a v-if="!item.is_get" @click="!disabled && getReward(item)" class="screen_content_item_btn"></a>
              <a v-else @click="" class="screen_content_item_btn_disabled"></a>
            </template>
            <template v-else>
              <a class="screen_content_item_btn_go" @click="!disabled && doTask(item)" id="my-code" href="javascript:;"
                :data-clipboard-text='"《提灯与地下城 重制版》1亿钻石暴击赠送中！点击链接即可瓜分钻石，快来迎接这泼天的富贵吧！" + shareLink'></a>
            </template>
          </div>
        </div>

      </div>
      <div :class="['hammer_box', { 'active': active }, { 'disabled': disabled }]">
        <div class="hammer"></div>
      </div>
      <div class="gold"></div>
      <div class="diamond"></div>
      <div class="energy">
        <div>{{ activity.times }}</div>
      </div>
      <div class="ten"></div>
      <div class="ten_text"></div>
    </div>
    <div @click.self="openResultList = false" :class="['resultList', { 'openResultList': openResultList }]">
      <div class="resultList-container">
        <div class="result" v-for="(result, index) in resultList" :key="index">{{ `Round${index + 1}: ${result}` }}</div>
      </div>
    </div>


  </div>
</template>

<script>
import Gift from './Gift'
import { mapState, mapMutations } from 'vuex';
import { Toast } from 'mint-ui';
export default {
  name: 'SlotMachine',
  components: {
    Gift
  },
  props: {
    configs: {
      type: Array,
      default: () => []
    },
    trigger: {
      type: Date,
      default: false
    },
    taksInfo: {
      type: Array,
      default: () => []
    },
    shareLink: {
      type: String,
      default: ''
    },
    activity: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
      run3D: false,
      active: false,
      disabled: false,
      openResultList: false,
      resultList: [],
      result: [],
      screen_content: [
        {
          path: require(`@/assets/images/active/tideng/third/03/machine/1.png`),
          lock: true,
          id: 1
        },
        {
          path: require(`@/assets/images/active/tideng/third/03/machine/2.png`),
          lock: false,
          id: 2
        },
        {
          path: require(`@/assets/images/active/tideng/third/03/machine/3.png`),
          lock: false,
          id: 3
        },
      ],

    }
  },
  created() {
    // function getTimestampForDate(year, month, day, hour) {
    //   const dateObj = new Date(year, month - 1, day, hour);
    //   const timestamp = dateObj.getTime();

    //   return timestamp;
    // }
    // function getCurrentTimestamp() {
    //   const dateObj = new Date();
    //   const timestamp = dateObj.getTime();

    //   return timestamp;
    // }

    // // 使用示例
    // const year = 2024; // 年份
    // const month = 2; // 月份，2表示二月
    // const day = 29; // 日期
    // const hour = 0; // 小时
    // const timestamp = getTimestampForDate(year, month, day, hour)
    // const currentTimeStamp = getCurrentTimestamp()
    // if (timestamp <= currentTimeStamp) {
    //   console.log('指定日期时间已过');
    //   this.screen_content[0].lock = false
    // } else {
    //   console.log('指定日期时间');
    //   this.screen_content[0].lock = true
    // }
  },
  watch: {
    taksInfo: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue.length) {
            newValue.forEach((item, index) => {
              this.screen_content[index].is_get = item.is_get
              this.screen_content[index]._get = item._get
            })
          } else {
          }
        }
      }
    },
    disabled: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.$emit('disabled', 1)
        } else {
          this.$emit('disabled', 2)
        }
      }
    },
    activity: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue.is_task_start) {
            this.screen_content[0].lock = false
          } else {
            this.screen_content[0].lock = true
          }
        }

      }
    },
  },
  methods: {
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    bubbling(key) {
      this.$emit('bubbling', key)
    },
    doTask(item) {
      this.$emit('doTask', item.id)
    },
    getReward(item) {
      this.$emit('getReward', item.id)
    },
    turn() {
      if (!this.userInfo.account) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return
      }
      if (!this.activity.times) {
        return this.bubbling('moreShow')
      }
      if (!this.activity.is_has_number) {
        return this.onToast('很抱歉,活动剩余钻石不足！')
      }
      if (this.activity.is_today_exchange) {
        return this.onToast('很抱歉,您今天已经兑换过奖励，请明日来抽奖!')
      }
      this.active = true
      setTimeout(() => {
        this.$emit('lottery')
        this.active = false
      }, 2000)
      this.disabled = true
    },
    isFinished(val) {
      const autoTurnList = this.$el.querySelectorAll('.autoTurn')
      this.result.push(val)
      const resultSum = this.result.reduce((item1, item2) => item1 + item2, 0)
      if (this.result.length > 2) {
        console.log('activeText')
        if (resultSum) {
          this.$emit('activeText')
        }
      }
      if (autoTurnList.length === 1) {
        this.disabled = false
        this.resultList.push(this.result)
        this.result = []
      }
    },
    closePopup(name) {
      this[name] = false;
    },
    ...mapMutations([
      "changeLoginPopup",
    ]),
  },
  computed: {
    ...mapState([
      'userInfo'
    ])
  },
}
</script>

<style lang="less" scoped>
@import url("./SlotMachine.less");
</style>



// WEBPACK FOOTER //
// src/pages/tideng/third/components/SlotMachine/SlotMachine.vue